import * as React from "react";
import PropTypes from "prop-types";
export function withLang(Component: React.ComponentType) {
  return class extends React.Component<typeof Component & { lang: string }> {
    static contextTypes = {
      language: PropTypes.shape({
        currLang: PropTypes.string,
      }),
    };

    render() {
      return <Component lang={this.context.language?.currLang} {...this.props} />;
    }
  };
}
